import React from 'react';
import classnames from 'classnames';
import s from './ThumbOverlayBackground.scss';
const ThumbOverlayBackground = ({ type , className  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s[type], className)
    });
ThumbOverlayBackground.displayName = 'ThumbOverlayBackground';
export default ThumbOverlayBackground;
